export interface ValidationAnnouncementProps {
  /** What to announce. Empty while the form has nothing to report. */
  message: string;
  'data-testid'?: string;
}

/**
 * ACP-2092 (Section 508): validation errors are announced from here. The region is
 * always mounted and starts empty — a live region only announces changes to text it
 * already owns, so one rendered on demand is announced inconsistently or not at all.
 *
 * It carries no visible text: the page's error presentation (red border plus the
 * message on the error icon's tooltip) is the established pattern across every form
 * component, and changing that is a design decision beyond this fix.
 *
 * No explicit role: `role="status"` carries implicit polite semantics, which
 * contradicts `aria-live="assertive"` and is resolved differently across screen
 * readers. The aria-live/aria-atomic pair alone is unambiguous.
 */
export function ValidationAnnouncement({ message, 'data-testid': dataTestId }: ValidationAnnouncementProps) {
  return (
    <div
      aria-atomic='true'
      aria-live='assertive'
      className='ds-u-visibility--screen-reader'
      data-testid={dataTestId}>
      {message}
    </div>
  );
}

export default ValidationAnnouncement;
